import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable()
export class AdirApiUrlInterceptor implements HttpInterceptor {
  // API route mappings
  private readonly apiRouteMap = new Map<string, string>([
    ['v1/users', environment.userManagementApiConfig.uri],
    ['v1/fdp', environment.fdpApiConfig.uri],
  ]);

  // Default API URI
  private readonly defaultApiUri = environment.adirApiConfig.uri;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.startsWith('http')) {
      return next.handle(req);
    }

    // Remove leading slash if present
    const path = req.url.startsWith('/') ? req.url.slice(1) : req.url;

    // Find the matching base URI for the path
    const baseUri = this.findMatchingBaseUri(path);

    let apiReq = req.clone({
      withCredentials: true,
    });

    try {
      // Create the full URL
      const url = new URL(path, baseUri);
      apiReq = apiReq.clone({
        url: url.href,
      });
    } catch (error) { }

    return next.handle(apiReq);
  }

  private findMatchingBaseUri(path: string): string {
    // Find the first matching route pattern
    for (const [pattern, uri] of this.apiRouteMap) {
      if (path.startsWith(pattern)) {
        return uri;
      }
    }
    // Return default API URI if no specific match found
    return this.defaultApiUri;
  }
}
